import React from "react";
import {
  Create,
  SimpleForm,
  FileField,
  Toolbar,
  FileInput,
  ListButton,
  SaveButton,
} from "react-admin";
import { onAddAppInstallationTaskAppIDUploadCreateValidationCreate } from "../../Service/Validation/AddBonusValidation";
import { TestNameSelectInput } from '../../UI/Input/SelectInput'
import Grid from "@material-ui/core/Grid";

const PageTitle = () => {
  return <span>Upload App Id</span>;
};

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="show" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const AddAppInstallationTaskAppIdUploadCreate = (props) => {

  return (
    <Create title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm toolbar={<FormToolbar />} reValidateMode="onBlur" warnWhenUnsavedChanges validate={onAddAppInstallationTaskAppIDUploadCreateValidationCreate}>
        <SanitizedGrid container spacing={3} fullWidth>
          <FileInput source="attachments">
            <FileField source="src" title="title" />
          </FileInput>         
        </SanitizedGrid>

      </SimpleForm>
    </Create>
  );
};
export default AddAppInstallationTaskAppIdUploadCreate;
